import React from 'react';
import { connect } from 'react-redux'
import { sortBy, chunk, keys } from 'lodash'
import { Link } from 'react-router-dom'
import './index.css'


class DataExplorerCountries extends React.PureComponent {
  render() {
    const { countries } = this.props
    const countryCodes = sortBy(keys(countries), i => countries[i])
    const splitCountries = chunk(countryCodes,  (countryCodes.length/3)+1)

    return (
      <div>
        <h2 className="f2 lh-title text-orange">Countries</h2>
        { splitCountries.map((column, i) => (
          <div key={i} className="fl w-third pa1">
            { column.map(countryCode => (
              <div key={countryCode}>
                <Link className="no-underline underline-hover text-blue Countries__country" to={`/countries/${countryCode}`} >{ countries[countryCode] }</Link>
              </div>
            )) }
          </div>
        )) }
      </div>
    )
  }
}


const mapStateToProps = state => ({
  countries: state.countries,
})

export default connect(mapStateToProps, undefined)(DataExplorerCountries)



// WEBPACK FOOTER //
// ./src/pages/DataExplorerCountries/index.js